import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import Imagem from 'Component/Imagem';
import Usuario from 'Interface/Usuarios';

interface Props {
  dados: Usuario;
}

const FaltandoDocumentacaoLista = ({ dados }: Props): React.ReactElement => {
  return (
    <div className="d-flex border-bottom align-items-center py-2 px-3">
      <Imagem
        src={dados.imagem}
        alt={dados.nome}
        className="rounded-circle object-fit-cover"
        width="80"
        height="80"
      />
      <div className="ms-4 fs-5">
        <Link to={`/usuarios/editar/${dados.id}?aba=2`} target="_blank" className="text-decoration-none">
          {dados.nome}
        </Link>
        <small className="d-block fs-6 text-muted">Nome</small>
      </div>
      <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end">
        <div className="ms-5 fs-6 text-end">
          {Object.keys(dados)
            .filter((documento: string) => !dados[documento])
            .join(', ')}
          <small className="d-block fs-6 text-muted">Documentos faltando</small>
        </div>
      </BrowserView>
    </div>
  );
};

export default FaltandoDocumentacaoLista;
